import {Pipe, PipeTransform} from '@angular/core';
import {DecimalPipe} from '@angular/common';

@Pipe({
    name: 'decimalConverter'
})
export class DecimalConverter implements PipeTransform {

    constructor(private decimalPipe: DecimalPipe) {
    }

    transform(value: any, args?: any): any {
        if (!isNaN(value)) {
            try {
                return this.decimalPipe.transform(value, '1.2-2');
            } catch (e) {
                return value;
            }
        }

        return value;
    }
}
